<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.allowences')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.allowences')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-5">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('allowences.allowenceList')}}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <input
                  type="text"
                  :placeholder="$ml.get('general.search')"
                  v-model="searchText"
                  class="form-control"
                  autocomplete="false"
                  style="margin-bottom:10px;"
                />
              <div
                v-show="allowenceList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="allowence2 in allowenceList" :key="allowence2.id">
                      <td>
                        <span>{{allowence2.name}}</span>
                      </td>
                      <td>
                        <span>{{allowence2.shortCode}}</span>
                      </td>
                      <td>
                        <button class="btn btn-primary btn-sm" @click="getAllowence(allowence2.id)">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                    <tr></tr>
                  </tbody>
                </table>
              </div>
              <div v-show="allowenceList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get('allowences.allowenceNotRecord')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-7">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{$ml.get('allowences.allowenceInfo')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button
                  v-show="authControl == 0"
                  @click="newAllowence()"
                  type="button"
                  class="btn btn-sm btn-warning "
                >{{$ml.get('allowences.newAllowence')}}</button>
              </div>
            </div>
            <div class="box-body" align="center">
              <div class="row" style="margin-top:10px;">
                <div class="col-sm-3">
                  <h5>
                    <span>{{$ml.get('allowences.shortCode')}}</span> :
                  </h5>
                </div>
                <div class="col-sm-9" align="center">
                  <input type="text" v-model="allowence.shortCode" class="form-control" />
                </div>
              </div>
              <div class="row" style="margin-top:10px;">
                <div class="col-sm-3">
                  <h5>
                    <span>{{$ml.get('allowences.allowenceName')}}</span> :
                  </h5>
                </div>
                <div class="col-sm-9">
                  <input type="text" v-model="allowence.name" class="form-control" />
                </div>
              </div>
              <div class="row" style="margin-top:10px;">
                <div class="col-sm-3">
                  <h5>
                    <span>{{$ml.get('allowences.monthlyPayrollColumn')}}</span> :
                  </h5>
                </div>
                <div class="col-sm-9">
                  <select @change="changeMonthlyPayrollType($event)" class="form-control">
                    <option selected="selected" value="0">{{$ml.get('general.select')}}</option>
                    <option
                      v-for="monthlyPayroll in monthlyPayrollList"
                      :key="monthlyPayroll.id"
                      :value="monthlyPayroll.id"
                      :selected="monthlyPayroll.id == allowence.monthlyPayrollId"
                    >{{monthlyPayroll.name}}</option>
                  </select>
                </div>
              </div>
              <div class="row" style="margin-top:10px;">
                <div class="col-sm-3">
                  <h5>
                    <span>{{$ml.get('allowences.dailyPayrollColumn')}}</span> :
                  </h5>
                </div>
                <div class="col-sm-9">
                  <select @change="changePayrollType($event)" class="form-control">
                    <option selected="selected" value="0">{{$ml.get('general.select')}}</option>
                    <option
                      v-for="payroll in dailyPayrollList"
                      :key="payroll.id"
                      :value="payroll.id"
                      :selected="allowence.dailyPayrollId == payroll.id"
                    >{{payroll.name}}</option>
                  </select>
                </div>
              </div>
              <div class="row" style="margin-top:10px;">
                <div class="col-sm-3">
                  <h5>
                    <span>{{$ml.get('allowences.fullWorkTimeInDay')}}</span> :
                  </h5>
                </div>
                <div class="col-sm-9">
                  <input type="time" class="form-control" v-model="allowence.dayTime" />
                </div>
              </div>
              <div class="row" style="margin-top:10px;">
                <div class="col-sm-3">
                  <h5>
                    <span>{{$ml.get('allowences.color')}}</span> :
                  </h5>
                </div>
                <div class="col-sm-9">
                  <input
                    type="color"
                    class="form-control"
                    @change="changeColor($event)"
                    :value="this.allowence.colorCode"
                  />
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button
                  v-show="!isNewAllowence && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-sil"
                  class="btn btn-sm btn-danger "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.delete')}}</button>
                <button
                  v-show="isNewAllowence && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-kaydet"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.save')}}</button>
                <button
                  v-show="!isNewAllowence && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-guncelle"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.update')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.update')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.allowence.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('allowences.isContinueAllowenceUpdate')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveAllowence()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.save')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{this.allowence.name}}</p>
              <span>{{$ml.get('allowences.isContinueAllowenceSave')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveAllowence()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.delete')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.allowence.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('allowences.isContinueAllowenceDelete')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="deleteAllowence()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{$ml.get('general.delete')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      allowence: {
        id: null,
        shortCode: "",
        name: "",
        monthlyPayrollId: null,
        dailyPayrollId: null,
        dayTime: "00:00",
        colorCode: "#ff4545",
        r: 0,
        g: 0,
        b: 0
      },
      allowences: [],
      monthlyPayrolls: [],
      dailyPayrolls: [],
      isNewAllowence: true
    };
  },
  computed: {
    authControl(){
      return this.$store.getters.getAuthTanimlamalar;
    },
    allowenceList() {
      if(this.searchText){
        return this.allowences.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else {
      return this.allowences;
      }
    },
    dailyPayrollList() {
      return this.dailyPayrolls;
    },
    monthlyPayrollList() {
      return this.monthlyPayrolls;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    changeColor(event) {
      const colorCode = event.target.value;
      this.allowence.r = parseInt(colorCode.substr(1, 2), 16);
      this.allowence.g = parseInt(colorCode.substr(3, 2), 16);
      this.allowence.b = parseInt(colorCode.substr(5, 2), 16);
      this.allowence.colorCode = colorCode;
    },
    rgbToHex(rgb) {
      var hex = Number(rgb).toString(16);
      if (hex.length < 2) {
        hex = "0" + hex;
      }
      return hex;
    },
    fullColorHex(r, g, b) {
      var red = this.rgbToHex(r);
      var green = this.rgbToHex(g);
      var blue = this.rgbToHex(b);
      return "#" + red + green + blue;
    },
    changeMonthlyPayrollType(event) {
      this.allowence.monthlyPayrollId = event.target.value;
    },
    changePayrollType(event) {
      this.allowence.dailyPayrollId = event.target.value;
    },
    newAllowence() {
      this.isLoadingDetail = true;
      this.isNewAllowence = true;
      this.allowence.id = null;
      this.allowence.shortCode = "";
      this.allowence.name = "";
      this.allowence.monthlyPayrollId = null;
      this.allowence.dailyPayrollId = null;
      this.allowence.dayTime = "00:00";
      this.allowence.colorCode = "#ff4545";
      this.allowence.r = 0;
      this.allowence.g = 0;
      this.allowence.b = 0;
      this.isLoadingDetail = false;
    },
    async deleteAllowence() {
      try {
        this.isLoadingDetail = true;
        let id = this.allowence.id;
        const response = await this.$axios
          .delete("/Allowences/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getAllowences();
        this.newAllowence();
        alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
        this.isLoadingDetail = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingDetail = false;
      }
    },
    async saveAllowence() {
      if (this.allowence.name == "" || this.allowence.shortCode == "") {
        alertify.warning(this.$ml.get('alerts.pleaseEnterShortCodeAndName'));
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewAllowence) {
        try {
          let allowence2 = this.allowence;
          const response = await this.$axios
            .post("/Allowences", {
              name: allowence2.name,
              shortCode: allowence2.shortCode,
              monthlyPayrollId: allowence2.monthlyPayrollId,
              dailyPayrollId: allowence2.dailyPayrollId,
              dayTime: allowence2.dayTime,
              colorCode: allowence2.colorCode,
              r: allowence2.r,
              g: allowence2.g,
              b: allowence2.b
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.savedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getAllowences();
          this.getAllowence(id);
          this.isNewAllowence = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let allowence2 = this.allowence;
          const response = await this.$axios
            .post("/Allowences/" + allowence2.id, {
              name: allowence2.name,
              shortCode: allowence2.shortCode,
              monthlyPayrollId: allowence2.monthlyPayrollId,
              dailyPayrollId: allowence2.dailyPayrollId,
              dayTime: allowence2.dayTime,
              colorCode: allowence2.colorCode,
              r: allowence2.r,
              g: allowence2.g,
              b: allowence2.b
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getAllowences();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getAllowence(id) {
      try {
        this.isLoadingDetail = true;
        const response = await this.$axios
          .get("/Allowences/" + id)
          .then(response => {
            this.isNewAllowence = false;
            this.allowence.id = id;
            this.allowence.shortCode = response.data.shortCode;
            this.allowence.name = response.data.name;
            this.allowence.monthlyPayrollId = response.data.monthlyPayrollId;
            this.allowence.dailyPayrollId = response.data.dailyPayrollId;
            this.allowence.dayTime = response.data.dayTime
              ? this.toDateFormat(response.data.dayTime, "ss:dd")
              : "";
            this.allowence.r = response.data.r;
            this.allowence.g = response.data.g;
            this.allowence.b = response.data.b;
            this.allowence.colorCode = this.fullColorHex(
              response.data.r,
              response.data.g,
              response.data.b
            );
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoadingDetail = false;
      }
    },
    async getAllowences() {
      try {
        this.isLoading = true;
        const allowences = [];
        const response = await this.$axios
          .get("/Allowences")
          .then(response => {
            response.data.forEach(doc => {
              allowences.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                monthlyPayrollId: doc.monthlyPayrollId,
                dailyPayrollId: doc.dailyPayrollId,
                dayTime: doc.dayTime,
                colorCode: doc.colorCode,
                r: doc.r,
                g: doc.g,
                b: doc.b
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.allowences = allowences;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getDailyPayrolls() {
      try {
        this.isLoadingDetail = true;
        const dailyPayrolls = [];
        const response = await this.$axios
          .get("/Payroll")
          .then(response => {
            response.data.forEach(doc => {
              dailyPayrolls.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                type: doc.type,
                otherType: doc.otherPayrollTypes,
                equalType: doc.equalPayroll,
                maxLimit: doc.maxLimit,
                monthlyPayrollId: doc.monthlyPayroll,
                isApproved: doc.isApproved,
                multiplier: doc.multiplier,
                firstTolerance1: doc.firstTolerance1,
                lastTolerance1: doc.lastTolerance1,
                totalTolerance1: doc.totalTolerance1,
                firstTolerance2: doc.firstTolerance2,
                lastTolerance2: doc.lastTolerance2,
                totalTolerance2: doc.totalTolerance2,
                firstTolerance3: doc.firstTolerance3,
                lastTolerance3: doc.lastTolerance3,
                totalTolerance3: doc.totalTolerance3
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.dailyPayrolls = dailyPayrolls;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingDetail = false;
      }
    },
    async getMonthlyPayrolls() {
      try {
        this.isLoadingDetail = true;
        const monthlyPayrolls = [];
        const response = await this.$axios
          .get("/MonthlyPayroll")
          .then(response => {
            response.data.forEach(doc => {
              monthlyPayrolls.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                ssk: doc.ssk,
                total: doc.total,
                work: doc.work
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.monthlyPayrolls = monthlyPayrolls;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingDetail = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage')
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getAllowences();
    await this.getMonthlyPayrolls();
    await this.getDailyPayrolls();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/allowences/Allowences.vue